export const GrossSalaryFilter = {
  Year: "year" as const,
}

export const SalarySpecificationFilter = {
  Year: "year" as const,
  PersonId: "personId" as const,
  PersonName: "personName" as const,
}

export const GrossSalaryItem = {
  PersonId: "personId" as const,
  PersonName: "personName" as const,
}

export const AddExtraSalary = {
  Employee: "employee" as const,
  Amount: "amount" as const,
}

export const WintSalaryReportFilter = {
  YearMonthRange: "yearMonthRange" as const,
  PersonSearchName: "personSearchName" as const,
  Persons: "persons" as const,
  SalaryStates: "salaryStates" as const,
  PaymentStates: "paymentStates" as const,
}

export const GrossSalaryChange = {
  GrossSalary: "grossSalary" as const,
  TaxType: "taxType" as const,
}

export const EarlyPayout = {
  Employee: "employee" as const,
  PayoutDate: "payoutDate" as const,
  AmountType: "amountType" as const,
  PayoutAmount: "payoutAmount" as const,
  PayoutType: "payoutType" as const,
  UseOneTimeTax: "useOneTimeTax" as const,
}

export const ChildCreate = {
  Name: "name" as const,
  DateOfBirth: "dateOfBirth" as const,
  SoleCustody: "soleCustody" as const,
}

